import { useSentinel } from '@contexts/Sentinel'
import {
  Container,
  SentinelContainer,
  Header,
  AppContainer,
} from './Sentinel.styles'
import { Typography, IconButton } from '@mui/material'
import SentinelChat from '@components/organisms/SentinelChat/SentinelChat'
import BlurCircularOutlinedIcon from '@mui/icons-material/BlurCircularOutlined'
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined'

function SentinelComponent({ children }: { children: React.ReactNode }) {
  const { isOpen, closeSentinel } = useSentinel()

  return (
    <Container>
      <AppContainer>{children}</AppContainer>
      {isOpen && (
        <SentinelContainer>
          <Header>
            <BlurCircularOutlinedIcon />
            <Typography
              variant="$font-title-4"
              color="$color-text-primary"
              align="left"
              sx={{ flex: 1, marginLeft: '10px' }}
            >
              Sentinela
            </Typography>
            <IconButton onClick={closeSentinel}>
              <CloseOutlinedIcon />
            </IconButton>
          </Header>
          <SentinelChat />
        </SentinelContainer>
      )}
    </Container>
  )
}

export default SentinelComponent
